import React from 'react';
import _ from 'lodash';
import { Svg } from '@mlc/web-ui-toolkit';
import { faExternalLink } from '@fortawesome/pro-regular-svg-icons';
import { chevronRight } from '@mlc/symbols';
import * as Styled from './styled';
import callToActionTestIds from './CallToAction.elements';

interface Props {
	name: string;
	link: string;
	text: string;
	icon: string;
	launch: string;
}

const CallToAction: React.FunctionComponent<Props> = props => (
	<Styled.Card>
		<Styled.Anchor
			href={props.link}
			target={props.launch === 'new' ? '_blank' : '_self'}
			data-id={callToActionTestIds.ctaAnchor}
			analyticsId={_.kebabCase(props.name)}
		>
			<Styled.Img source={props.icon} alt={props.name} />
			<Styled.Title data-id={callToActionTestIds.ctaTitle} variant="button">
				<CallToActionTitle
					name={props.name}
					opensNewTab={props.launch === 'new' ? true : false}
				/>
			</Styled.Title>
			<Styled.Text m={0}>{props.text}</Styled.Text>
		</Styled.Anchor>
	</Styled.Card>
);

interface TitleProps {
	name: string;
	opensNewTab: boolean;
}

const CallToActionTitle: React.FunctionComponent<TitleProps> = props => (
	<React.Fragment>
		{props.name}
		{props.opensNewTab ? (
			<React.Fragment>
				<span className="sr-only">, opens in a new window.</span>
				<Styled.NewTabIcon icon={faExternalLink} size="xs" />
			</React.Fragment>
		) : (
			<Svg height={10} width={10} symbol={chevronRight} />
		)}
	</React.Fragment>
);

export default CallToAction;
